import button from '@/components/button'
import confirmButtonDialog from '@/components/button/confirm/dialog'

function renderDialog(h) {
  if (this.dialog) {
    return h(
      confirmButtonDialog,
      {
        props: {
          value: this.showDialog,
          title: this.$_title,
          callback: this.emitInput
        }
      }
    )
  }
}
function renderButton(h) {
  return h(
    button,
    {
      props: {
        label: this.$_label,
        icon: this.icon,
        mode: this.mode,
        color: this.color,
        loading: this.loading,
        disabled: this.$_disabled
      },
      on: {
        click: () => {
          if (this.dialog) {
            this.showDialog = true
          } else {
            this.emitInput()
          }
        }
      },
      scopedSlots: {
        dialog: () => {
          return renderDialog.call(this, h)
        }
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: 'grid grid-gap--8',
      style: { 'grid-template-columns': '1fr auto' }
    },
    [
      this.$slots.default,
      renderButton.call(this, h)
    ]
  )
}
